/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import SurveyCreateQuestions from '../lib/questions';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import SurveyCreateFormInfo from '../lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';
import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function SurveyCreatePage() {
  const { ticketDetail } = useTypedSelector((state) => state.Tickets);
  const { questions, surveyCreate } = useTypedSelector((state) => state.Survey);
  const { surveyQuestionListAction } = useActions();

  const formRef = useRef<{ submitForm: () => void } | null>(null);

  useEffect(() => {
    surveyQuestionListAction([]);
  }, []);

  return (
    <S.Container>
      <PageTitle title="Create New Survey" />
      {/*
       * Two stacked cards and an action bar, rather than three Bootstrap
       * `col-md-12` rows and a bare button left-aligned under them with
       * `marginRight: auto` doing nothing.
       */}
      <S.Stack>
        <SurveyCreateFormInfo ref={formRef} questions={questions} />
        <SurveyCreateQuestions data={ticketDetail.data} questions={questions} isUpdate={false} />
      </S.Stack>

      <S.Actions>
        <OutlineButton link="/panel/survey">Cancel</OutlineButton>
        <PrimaryButton onClick={() => formRef.current?.submitForm()}>Create survey</PrimaryButton>
      </S.Actions>

      <AppLoading loading={surveyCreate.loading} />
    </S.Container>
  );
}
